# jQuery replacement functions
#
# some functions derive from https://youmightnotneedjquery.com/ and 
# https://github.com/camsong/You-Dont-Need-jQuery

window.$$ = 

  add_delegated_listener: (el, eventName, selector, callback) ->

    el.addEventListener eventName, (e) ->
      try 
        target = e.target
        while target && target != el
          if target.matches selector
            callback.call target, e
            break
          target = target.parentNode
      catch e
        console.log('Got error in add_delegated_listener')
        console.error(e)

    , false

  closest: (el, selector) -> 
    if el.closest?
      el.closest(selector)
    else 
      matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
      current_el = el
      while (current_el)
        if matchesSelector.call(current_el, selector)
          return current_el
        else
          current_el = current_el.parentElement

      null

  height: (el) -> 
    # console.log "HEIGHT", Math.round(el.getBoundingClientRect().height), el.clientHeight, el.offsetHeight
    # Math.round el.getBoundingClientRect().height
    Math.round el.clientHeight

  width: (el) -> 
    Math.round el.getBoundingClientRect().width


  offset: (el) ->
    rect = el.getBoundingClientRect()

    top  = rect.top  + window.pageYOffset - document.documentElement.clientTop
    left = rect.left + window.pageXOffset - document.documentElement.clientLeft

    {top, left}


  offsetParent: (el) ->
    el.offsetParent or el

  scrollTop: (el) -> 
    el ?= document
    (el.documentElement && el.documentElement.scrollTop) || el.body.scrollTop

  # TODO: figure out how to handle parameters
  animate: (el, params, speed) -> 
    el.style.transition = 'all ' + speed
    
    for k,v of params
      el.style[k] = v


  ensureInView: (el, options = {}) ->

    if !el
      options.callback()
      return


    try 
      _.defaults options,
        fill_threshold: 0
        offset_buffer: 36
        scroll: true
        position: 'top' 
        speed: null
        speed_mult: 1
        callback: ->

      el_height = $$.height(el) + (options.extra_height or 0)

      el_top = $$.offset(el).top
      el_bottom = el_top + el_height

      doc_height = $$.height(document.body)
      doc_top = $$.scrollTop()

      doc_bottom = doc_top + doc_height
      is_onscreen = el_top > doc_top && el_bottom < doc_bottom

      #if less than 50% of the viewport is taken up by the el...
      bottom_inside = el_bottom < doc_bottom && (el_bottom - doc_top) > options.fill_threshold * el_height
      top_inside = el_top > doc_top && (doc_bottom - el_top) > options.fill_threshold * el_height    
      no_adjustment_needed = !options.force && is_onscreen && top_inside && bottom_inside  

      if !no_adjustment_needed

        switch options.position 

          when 'top'
            target = el_top - options.offset_buffer
          when 'bottom'
            target = el_bottom - doc_height + options.offset_buffer
          else
            throw 'bad position for ensureInView'

        if options.scroll

          distance_to_travel = options.speed || Math.abs( doc_top - (el_top - options.offset_buffer) )

          if options.dom_possibly_shifting

            if options.position != 'top'
              console.error "smoothScrollToTargetWithChangingElement doesn't support position targets except 'top'"

            $$.smoothScrollToTargetWithChangingElements
              el: el
              offset_buffer: options.offset_buffer
              duration: options.speed_mult * Math.min(distance_to_travel, 1500)
              callback: options.callback

          else 
            $$.smoothScrollToTarget 
              target: el_top - options.offset_buffer
              duration: options.speed_mult * Math.min(distance_to_travel, 1500)
              callback: options.callback


        else 
          window.scrollTo 0, target
          options.callback()
      else
        options.callback()
    catch e
      console.log("Error in ensureInView")
      console.error(e)

  ensure_in_viewport_when_appears: (selector) -> 
    viewport_ensurer = setInterval ->
      el = document.querySelector selector
      if el 
        $$.ensureInView el, {scroll: true}
        clearInterval viewport_ensurer
    , 10


  smoothScrollToTargetWithChangingElements: ({duration, callback, el, offset_buffer}) ->
    target = $$.offset(el).top - offset_buffer

    diff = target - window.pageYOffset
    frames = 60 * duration / 1000
    dist_per_frame = diff / frames

    iter = (current_time) ->

      try 

        top = el.getBoundingClientRect().top
        if diff < 0 
          done = top + dist_per_frame > offset_buffer
        else 
          done = top - dist_per_frame < offset_buffer

        done ||= document.documentElement.scrollHeight - document.documentElement.scrollTop - document.documentElement.clientHeight <= 0


        if done 
          dist_per_frame = top - offset_buffer

        scroll_to = window.pageYOffset + dist_per_frame

        window.scrollTo 0, scroll_to

        if !done
          requestAnimationFrame(iter)
        else 
          callback?()
      catch e
        console.log("Error in smoothScrollToTargetWithChangingElements")
        console.error(e)

    requestAnimationFrame(iter)

  smoothScrollToTarget: ({target, duration, callback}) ->
    start_pos = window.pageYOffset
    diff = target - start_pos

    start_time = null

    iter = (current_time) ->
      try 
        if !start_time
          start_time = current_time

        time = current_time - start_time

        percent = Math.min time / duration, 1
        window.scrollTo 0, start_pos + diff * percent

        if time < duration
          requestId = window.requestAnimationFrame(iter)
        else
          window.cancelAnimationFrame requestId
          callback?()
      catch e 
        console.log("Got error in smoothScrollToTarget")
        console.error(e)

    requestId = window.requestAnimationFrame(iter)


  moveToTop: (el, options = {}) ->
    _.defaults options, 
      offset_buffer: 50

    el_top = $$.offset(el).top
    el_bottom = 
    target = el_top - options.offset_buffer

    window.scrollTo 0, target


  setStyles: (selector, styles) ->
    els = document.querySelectorAll selector

    for el in els 
      for k,v of styles
        if k.indexOf('-') > -1
          el.style.setProperty k, v
        else 
          el.style[k] = v






/** WEBPACK FOOTER **
 ** ./@client/element_viewport_positioning.coffee
 **/